<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12" md="4">
            <v-text-field
                v-model="search"
                variant="outlined"
                prepend-inner-icon="mdi-magnify"
                :label="$t('TableHeaders.Search')"
                density="comfortable"
                solo
                hide-details
                class="rounded-lg"
                color="white"
                style="font-family: Saira Condensed, sans-serif;"></v-text-field>
            </v-col>
            <v-col class="text-right" cols="12" md="2">
                <v-select
                v-model="selectedStatus"
                @update:model-value="sortByStatus()"
                variant="outlined"
                :label="$t('TableHeaders.Status')"
                density="comfortable"
                hide-details
                class="rounded-lg"
                :items="status"
                item-title="title"
                item-value="value"
                style="font-family: Saira Condensed, sans-serif;"
                ></v-select>
            </v-col> 
            <v-col class="text-right" cols="12" md="2">
                <v-select
                    v-model="selectedCategory"
                    @update:model-value="filterCategory()"
                    variant="outlined"
                    :label="$t('TableHeaders.Category')"
                    density="comfortable"
                    hide-details
                    class="rounded-lg"
                    :items="productCategory"
                    item-title="title"
                    item-value="value"
                    style="font-family: Saira Condensed, sans-serif;"
                ></v-select>
            </v-col> 
            <!-- <v-col class="text-right" cols="12" md="8">
                <v-btn
                @click="showAddDialog()"
                prepend-icon="mdi-plus"
                class="mt-2 rounded-lg"
                color="primary"
                height="40px"
                elevation="2" style="font-family: Saira Condensed, sans-serif;">
                    Add Product
                </v-btn>
            </v-col> -->
            <!-- <v-col cols="12">
                <v-expansion-panels multiple color="black">
                    <v-expansion-panel class="guide-panel">
                        <v-expansion-panel-title class="font-weight-bold">
                            📌{{ $t('Purchase_Guidelines.Header') }}
                        </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        <v-list class="guide-panel-content text-subtitle-2" dense>
                            <v-list-item>
                                ➤ ”PENDING” - {{ $t('Purchase_Guidelines.Pending') }}
                            </v-list-item>
                            <v-list-item>
                                ➤ “IN PROGRESS“ - {{ $t('Purchase_Guidelines.In_Progress') }}
                            </v-list-item>
                            <v-list-item>
                                ➤ “COMPLETED“ - {{ $t('Purchase_Guidelines.Completed') }}
                            </v-list-item>
                            <v-list-item>
                                ➤ “DECLINED“ - {{ $t('Purchase_Guidelines.Declined') }}
                            </v-list-item>
                            <v-list-item>
                                ➤ REFUND ICON - {{ $t('Purchase_Guidelines.Refund') }}
                            </v-list-item>
                        </v-list>
                    </v-expansion-panel-text>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col> -->
            <v-col cols="12">
                <v-card class="dt-container mt-2">
                    <v-data-table
                        :mobile="isMobileOrTablet()"
                        :headers="headers"
                        :items="data"
                        :search="search"
                        :loading="loading"
                        class="text-subtitle-1"
                        style="font-family: Saira Condensed, sans-serif;">
                    <template v-slot:loading>
                        <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                        <!-- <v-skeleton-loader type="table-row@10"></v-skeleton-loader> -->
                    </template>
                    
                    <template v-slot:item.product.category="{ item }">
                        <v-chip :color="getCategoryColor(item.product.category)" :text-color="getTextColor(item.product.category)">
                            {{ getCategoryLabel(item.product.category) }}
                        </v-chip>
                    </template>

                    <template v-slot:item.status="{ item }">
                        <v-chip v-if="item.status == 'pending'" color="orange">
                            <span>Pending</span>
                        </v-chip>
                        <v-chip v-if="item.status == 'inprogress'" color="blue">
                            <span>Inprogress</span>
                        </v-chip>
                        <v-chip v-if="item.status == 'completed'" color="green">
                            <span>Completed</span>
                        </v-chip>
                        <v-chip v-if="item.status == 'refunded'" color="gray">
                            <span>Refunded</span>
                        </v-chip>
                        <v-chip v-if="item.status == 'declined'" color="red">
                            <span>Declined</span>
                        </v-chip>
                    </template>

                    <template v-slot:[`item.action`]="{ item }">
                        <v-icon
                            v-if="item.status == 'pending' || item.status == 'inprogress'"
                            @click="showRefundDialog(item)"
                            class="me-2"
                            size="small"
                        >
                        mdi-credit-card-refund
                        </v-icon>
                        <v-icon
                            @click="showVieWDialog(item)"
                            class="me-2"
                            size="small"
                        >
                        mdi-eye
                        </v-icon>
                        <!-- <v-icon
                            @click="showEditDialog(item)"
                            class="me-2"
                            size="small"
                    >
                        mdi-pencil
                        </v-icon> -->
                        
                    </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>

    <v-dialog v-model="refundDialog" width="450" persistent>
        <v-card color="primary" rounded="lg" class="pa-2" style="font-family: Saira Condensed, sans-serif;">
            <v-card-text class="font-weight-bold">
                {{ $t('AlertDialog.Purchases.Refund_Message') }}
                <br><br>{{ $t('AlertDialog.Purchases.Transaction_Code') }}: {{ itemToRefund.ticketNumber}}
                <br>{{ $t('AlertDialog.Purchases.Product') }}: {{ itemToRefund.product.title}}
                <br>{{ $t('AlertDialog.Purchases.User') }}: {{ itemToRefund.user.username}}
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="refundDialog = false" :disabled="loadingRefund" variant="outlined">
                {{ $t('Buttons.Cancel') }}
            </v-btn>

            <v-btn @click="refundItem()" :loading="loadingRefund" color="red" variant="elevated">
                {{ $t('Buttons.Confirm') }}
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <v-snackbar
        v-model="snackbar"
        :timeout="2500"
        color="secondary"
        location="top">
        <v-icon>mdi-alert-circle</v-icon>
        <span class="ml-2" style="font-family: Saira Condensed, sans-serif;">{{ snackText }}</span>
    </v-snackbar>

    <PurchaseViewDialog ref="PurchaseViewDialog" v-on:refresh="sortByStatus()"></PurchaseViewDialog>

</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import PurchaseViewDialog from '../Dialogs/Views/PurchaseViewDialog.vue';

export default defineComponent({
    components: {
        PurchaseViewDialog
    },
    data(){
        return {
            data: [],
            originalData: [],
            refundDialog: false,
            itemToRefund: null,
            loadingRefund: false,
            search: null,
            loading: false,
            selectedStatus: 'all',
            selectedCategory: 'all',
            headers: [
                { title: this.$t('TableHeaders.Title'), align: 'start', sortable: true, key: 'ticketNumber' },
                { title: this.$t('TableHeaders.User'), align: 'start', sortable: true, key: 'user.displayName' },
                { title: this.$t('TableHeaders.Product'), align: 'start', sortable: true, key: 'product.title' },
                { title: this.$t('TableHeaders.Category'), align: 'start', sortable: true, key: 'product.category' },
                { title: this.$t('TableHeaders.Points'), align: 'start', sortable: true, key: 'amount' },
                { title: this.$t('TableHeaders.Status'), align: 'start', sortable: true, key: 'status' },
                { title: this.$t('TableHeaders.Actions'), align: 'end', sortable: false, key: 'action' },
            ],
            status: [
                { title: 'All', value: 'all' },
                { title: 'Pending', value: 'pending' },
                { title: 'Inprogress', value: 'inprogress' },
                { title: 'Completed', value: 'completed' },
                { title: 'Declined', value: 'declined' },
                { title: 'Refunded', value: 'refunded' },
            ],
            productCategory: [
                { title: 'All', value: 'all' },
                { title: 'Stake', value: 'stake' },
                { title: 'Kick', value: 'kick' },
            ],

            snackbar: false,
            snackText: null,
        }
    },
    methods: {
        async init(){
            const token = localStorage.getItem('maherco-admin-accesstoken')
            if(token){
                this.loading = true
                axios.get(process.env.VUE_APP_SERVER_URL + '/api/admin/store/purchases',
                { headers: 
                    { 
                        'Authorization': `Bearer ${token}`,
                        'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                    }
                }
                ).then((res)=>{
                    if(res){
                        this.originalData = res.data.purchases;
                        this.data = res.data.purchases;
                        this.loading = false
                    }
                }).catch((error) => {
                    if (error.response) {
                        if (error.response.status === 401) {
                                localStorage.removeItem("vuex");
                                localStorage.removeItem("maherco-admin-accesstoken");
                                window.location.reload();
                        } else {
                            console.log(`Error: ${error.response.status}`);
                        }
                    } 
                    else if (error.request) {
                        console.log('No response received', error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            }
            else{
                localStorage.removeItem("vuex");
                localStorage.removeItem("maherco-admin-accesstoken");
                window.location.reload();
            }
        },
        getCategoryLabel(category) {
            if (!category) return 'N/A';
            const trimmed = category.trim().toLowerCase();
            if (trimmed === 'stake') return 'Stake';
            if (trimmed === 'kick') return 'Kick';
            return trimmed;
        },

        getCategoryColor(category) {
            if (!category) return 'default';
            const trimmed = category.trim().toLowerCase();
            if (trimmed === 'kick') return 'green';
            if (trimmed === 'stake') return 'black';
            return 'blue';
        },

        getTextColor(category) {
            const trimmed = category?.trim().toLowerCase();
            if (trimmed === 'stake') return 'black';
            return 'white';
        },
        refundItem(){
            const token = localStorage.getItem('maherco-admin-accesstoken')
            this.loadingRefund = true
            let formData = {
                userId: this.itemToRefund.user._id,
                transactionCode: this.itemToRefund.transactionCode
            }
            axios.post(process.env.VUE_APP_SERVER_URL + '/api/admin/points/refund', formData,{ 
                headers: { 
                    'Authorization': `Bearer ${token}`,
                    'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                }
            }).then((res)=>{
                if(res){
                    this.init()
                    this.snackbar = true
                    this.snackText = 'Points successfully refunded!'
                    this.loadingRefund = false
                    this.refundDialog = false
                }
            }).catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                            localStorage.removeItem("vuex");
                            localStorage.removeItem("maherco-admin-accesstoken");
                            window.location.reload();
                    } else {
                        console.log(`Error: ${error.response.status}`);
                    }
                } 
                else if (error.request) {
                    console.log('No response received', error.request);
                } else {
                    console.log('Error', error.message);
                }
            });
        },
        sortByStatus(){ 
            if(this.selectedStatus == 'all'){
                this.init()
            }
            else{
                this.loading = true
                const token = localStorage.getItem('maherco-admin-accesstoken')
                axios.get(process.env.VUE_APP_SERVER_URL + '/api/admin/store/purchases?status=' + this.selectedStatus, { 
                    headers: { 
                        'Authorization': `Bearer ${token}`,
                        'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                    }
                }).then((res)=>{
                    if(res){
                        this.originalData = res.data.purchases;
                        this.data = res.data.purchases;
                        this.loading = false
                    }
                }).catch((error) => {
                    if (error.response) {
                        if (error.response.status === 401) {
                                localStorage.removeItem("vuex");
                                localStorage.removeItem("maherco-admin-accesstoken");
                                window.location.reload();
                        } else {
                            console.log(`Error: ${error.response.status}`);
                        }
                    } 
                    else if (error.request) {
                        console.log('No response received', error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            }
            
        },
        filterCategory() {
            if (this.selectedCategory === 'all') {
                this.data = this.originalData;
            } else {
                console.log('filter category hit with : ' + this.selectedCategory)
                this.data = this.originalData.filter(item => this.selectedCategory == item.product.category);
            }
        },
        showVieWDialog(data){
            this.$refs.PurchaseViewDialog.initView(data)
        },
        showRefundDialog(data){
            this.itemToRefund = data
            this.refundDialog = true
        }
    },
    mounted(){
        this.init()
    }
}) 
</script>

<style scoped>

</style>